import { Bell, Menu } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useNotifications } from "@/context/NotificationContext";

export function TopAppBar({ title }) {
  const { user } = useAuth();
  const { unread } = useNotifications();
  return (
    <header
      className="sticky top-0 z-40 h-14 bg-background/85 backdrop-blur supports-[backdrop-filter]:bg-background/70 border-b border-border"
      data-testid="top-app-bar"
    >
      <div className="max-w-[560px] mx-auto flex h-full items-center justify-between px-4">
        <div className="flex items-center gap-2">
          <div className="h-8 w-8 rounded-lg bg-primary grid place-items-center text-primary-foreground font-bold bb-display">B</div>
          <div className="leading-tight">
            <div className="text-sm font-semibold tracking-tight bb-display">{title || "BallBoy"}</div>
            {user && (
              <div className="text-[11px] text-muted-foreground capitalize">
                {user.role}
              </div>
            )}
          </div>
        </div>
        <div className="flex items-center gap-1">
          <Link to="/notifications">
            <Button
              variant="ghost"
              size="icon"
              aria-label="Notifications"
              data-testid="notifications-bell-button"
              className="relative"
            >
              <Bell className="h-5 w-5" />
              {unread > 0 && (
                <Badge
                  variant="destructive"
                  className="absolute -top-1 -right-1 h-5 min-w-5 px-1 rounded-full text-[10px]"
                >
                  {unread}
                </Badge>
              )}
            </Button>
          </Link>
        </div>
      </div>
    </header>
  );
}
